import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider, useLanguage } from "@/context/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProductsPage from "@/pages/ProductsPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";
import InsightsPage from "@/pages/InsightsPage";
import InsightUCP600Page from "@/pages/InsightUCP600Page";
import InsightZeroStoragePage from "@/pages/InsightZeroStoragePage";
import InsightConstructionPage from "@/pages/InsightConstructionPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import VowpacePage from "@/pages/VowpacePage";
import LCShieldPage from "@/pages/LCShieldPage";
import TermsPage from "@/pages/TermsPage";
import LogoPreview from "@/pages/LogoPreview";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const MINI_ICC_NOTE = {
  en: 'LC Shield is an independent tool and is not affiliated with or endorsed by the ICC.',
  'zh-TW': 'LC Shield 為獨立工具，與國際商會（ICC）無隸屬關係，亦未獲其認可。',
  'zh-CN': 'LC Shield 为独立工具，与国际商会（ICC）无隶属关系，亦未获其认可。',
};

function AppLayout() {
  const location = useLocation();
  const { lang } = useLanguage();
  const isProductDetail = location.pathname.startsWith('/products/') && location.pathname !== '/products';
  
  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/pricing" element={<Navigate to="/products" replace />} />
          <Route path="/products/miprose" element={<Navigate to="/products" replace />} />
          <Route path="/miprose" element={<Navigate to="/products" replace />} />
          <Route path="/products/vowpace" element={<VowpacePage />} />
          <Route path="/products/vowpace-ai" element={<VowpacePage />} />
          <Route path="/products/lc-shield" element={<LCShieldPage />} />
          <Route path="/products/:id" element={<Navigate to="/products" replace />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/ucp-600" element={<InsightUCP600Page />} />
          <Route path="/insights/zero-storage" element={<InsightZeroStoragePage />} />
          <Route path="/insights/construction-ai" element={<InsightConstructionPage />} />
          <Route path="/blog/ucp600-ai" element={<Navigate to="/insights/ucp-600" replace />} />
          <Route path="/blog/aso-guide" element={<Navigate to="/insights/ucp-600" replace />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/logo-preview" element={<LogoPreview />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      {!isProductDetail && <Footer />}
      {isProductDetail && (
        <footer className="bg-[#0a0a0a] border-t border-white/5 py-8">
          <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
            <p className="text-xs text-white/30">
              埵智有限公司 DZent Limited, Hong Kong.{' '}
              <a href="mailto:info@dzentlimited.com" className="hover:text-[#6366F1] transition-colors">info@dzentlimited.com</a>
              {' '}| LC Shield support:{' '}
              <a href="mailto:support@getlcshield.com" className="hover:text-[#6366F1] transition-colors">support@getlcshield.com</a>
            </p>
            <p className="text-xs text-white/20 mt-2">© 2026 埵智有限公司 DZent Limited. All rights reserved.</p>
            <p className="text-xs text-white/20 mt-1">{MINI_ICC_NOTE[lang] || MINI_ICC_NOTE.en}</p>
          </div>
        </footer>
      )}
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppLayout />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
